<script setup>
import { computed } from 'vue'
import { usePortalStore } from '@/store/portal'
import { useRoute } from 'vue-router'
import SupportFrame from '@/components/portal/SupportFrame.vue'
// 레거시 /download/ (kiraedu download/index.html, css .download) 화면을 그대로 옮겼다.
// 레거시에서 주석 처리돼 보이지 않던 MS오피스·한글·훈민정음 뷰어(대상 링크 대부분 폐쇄)는 넣지 않는다.
// 설치 파일은 이 사이트에 두지 않고 제작사 배포 페이지를 새 창으로 연다(레거시 window.open 과 같음).
// 레거시 대상 중 옮겨진 Adobe·xpdf 주소와 제3자 배포처(uptodown)였던 오픈오피스는 각 제작사 공식 내려받기 페이지로 바꿨다.
const GROUPS = [
  { title: '윈도우용', items: [
    { title: '아크로뱃 리더', icon: '/images/download/icon_download06.png', description: '아크로뱃 프로그램으로 작성된 문서(*.pdf) 보기를 지원하는 프로그램입니다.', href: 'https://www.adobe.com/kr/acrobat/pdf-reader.html' },
  ] },
  { title: '매킨토시용', items: [
    { title: '오픈오피스', icon: '/images/download/icon_download07.png', description: '오픈오피스는 기존 오피스 프로그램과의 뛰어난 호환성을 자랑합니다.', href: 'https://www.openoffice.org/download/' },
    { title: 'pdf 뷰어', icon: '/images/download/icon_download08.png', description: 'pdf로 저장된 문서 보기를 지원하는 프로그램입니다.', href: 'https://www.xpdfreader.com/download.html' },
  ] },
]
const route = useRoute(), portal = usePortalStore(), title = computed(() => portal.pageOf(route.meta.portalPage)?.title || '뷰어다운로드')
useHead(() => ({ title: `${title.value} · TECHEDU` }))
</script>
<template>
  <SupportFrame :title="title">
    <div class="viewer-download">
      <h2 class="vd-title">뷰어 프로그램 <span>다운로드</span></h2>
      <p class="vd-intro">뷰어 프로그램은 해당 문서들을 보기와 인쇄기능을 지원하는 프로그램입니다.<br>문서의 내용을 수정하거나 삭제하는 등의 편집작업은 할 수 없습니다.<br>뷰어 프로그램은 무료로 다운 받으실 수 있습니다.</p>
      <ul class="vd-groups">
        <li v-for="group in GROUPS" :key="group.title"><h3>{{ group.title }}</h3>
          <ul class="vd-cards">
            <li v-for="item in group.items" :key="item.title" class="vd-card"><h4 :style="{ backgroundImage: `url(${item.icon})` }">{{ item.title }}</h4><p>{{ item.description }}</p><a class="vd-button" :href="item.href" target="_blank" rel="noopener noreferrer" :aria-label="`${item.title} 다운로드 (새 창)`">다운로드</a></li>
          </ul>
        </li>
      </ul>
    </div>
  </SupportFrame>
</template>
<style scoped>
/* 치수·색은 레거시 css/userStyle.css .download 블록 값이다. */
.viewer-download{padding-bottom:20px;color:#343434;word-break:normal}
.viewer-download :where(h2,h3,h4,p,ul){margin:0;padding:0}
.vd-title{font-size:24px;font-weight:400;line-height:24px;color:#343434}
.vd-title span{color:#1082c4}
.vd-intro{margin-top:21px!important;font-size:15px;line-height:21px;color:#595959}
.vd-groups{list-style:none;margin-top:30px!important;padding-top:41px!important;border-top:1px solid #e6e6e6}
.vd-groups>li+li{margin-top:60px}
.vd-groups h3{font-size:24px;font-weight:400;line-height:24px;color:#666}
.vd-cards{list-style:none;display:flex;flex-wrap:wrap;gap:30px 28px;margin-top:16px!important;padding-bottom:30px!important}
.vd-card{box-sizing:border-box;width:285px;min-height:223px;padding:0 26px 26px;border:1px solid #ebebeb;background:#fff}
.vd-card h4{margin-top:28px!important;padding-left:36px!important;height:39px;background:0 0 no-repeat;background-size:39px 39px;font-size:20px;font-weight:400;line-height:39px;text-align:center;color:#666}
.vd-card p{margin-top:33px!important;min-height:34px;font-size:13px;line-height:17px;color:#696969}
.vd-button{display:block;box-sizing:border-box;height:37px;margin-top:12px;border:1px solid #ccc;border-radius:3px;background:#fff url('/images/download/down_btn.png') no-repeat right 13px top 6px;font-family:'Nanum Gothic','NanumGothic','Noto Sans KR','Malgun Gothic',sans-serif;font-size:14px;line-height:35px;text-align:center;color:#5e5e5e;text-decoration:none;cursor:pointer}
.vd-button:hover,.vd-button:focus-visible{color:#429ad9;border-color:#55aeed;background-image:url('/images/download/down_btn_on.png')}
.vd-button:focus-visible{outline:2px solid var(--tech-blue-soft,#2563eb);outline-offset:2px}
@media(max-width:640px){
  .viewer-download{padding-bottom:20px}
  .vd-title{font-size:22px}
  .vd-intro{font-size:14px}
  .vd-groups{margin-top:24px!important;padding-top:28px!important}
  .vd-groups>li+li{margin-top:40px}
  .vd-groups h3{font-size:21px;line-height:28px}
  .vd-cards{padding-bottom:0!important}
  .vd-cards{gap:16px}
  .vd-card{width:100%;min-height:0}
}
</style>
